"use client";

import { Message } from "@/lib/core/crm/types";
import { MessageActionHandlers } from "./hooks/useMessageActionHandlers";
import { MessageActionsMenu } from "./MessageActionsMenu";

interface MessageMobileHeaderActionsProps {
  message: Message;
  handlers: MessageActionHandlers;
  onCopyLink?: () => void;
  className?: string;
}

export function MessageMobileHeaderActions({
  message,
  handlers,
  onCopyLink,
  className,
}: MessageMobileHeaderActionsProps) {
  return (
    <div className={`sm:hidden ${className || ""}`}>
      <MessageActionsMenu message={message} handlers={handlers} onCopyLink={onCopyLink} />
    </div>
  );
}
